module.exports = __webpack_public_path__ + "static/img/120.98f485d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200921/120.jpg
// module id = T0pM
// module chunks = 0